import { CrmFunnelsConversationsService } from 'src/api/generated';
import { awaitCancelableRequest } from 'src/modules/shared/utils/api/cancelable-request.util';
import { reconcileConversationSnapshot } from '../cache/funnel-conversations/reconcile-snapshot.util';

/**
 * Canonical detail query shared by ordinary views and realtime HTTP recovery.
 * @param id - CRM conversation identity.
 * @returns Query options with cancellation and a canonical revision fence.
 */
export const conversationQueryOptions = (id: number) => ({
  queryKey: ['crm/funnel-conversations', id],
  structuralSharing: reconcileConversationSnapshot,
  queryFn: async ({ signal }: { signal: AbortSignal }) => {
    return await awaitCancelableRequest(
      CrmFunnelsConversationsService.getFunnelConversation(id),
      signal
    );
  },
});
